import {AxiosError} from 'axios';
import {useMutation} from 'react-query';
import {toast} from 'react-toastify';
import PatchLabRequirement from '.';

interface IPatchLabRequirementProps {
  onSuccess?: (data: any) => void;
  guid?: string;
}

const usePatchLabRequirement = ({
  onSuccess,
  guid,
}: IPatchLabRequirementProps) => {
  const {isLoading, mutate, isSuccess} = useMutation({
    mutationFn: (payload: ILabRequirementPayload) => {
      return PatchLabRequirement(payload, guid);
    },
    onSuccess: data => {
      onSuccess && onSuccess(data);
    },
    onError: (error: AxiosError<IAxiosErr>) => {
      toast.error(
        error?.response?.data?.message ||
          'مشکلی پیش آمده ،لطفا در زمان دیگری مراجعه فرمایید',
      );
    },
  });

  return {isLoading, mutate, isSuccess};
};

export {usePatchLabRequirement};
